import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { RouterProvider } from '@tanstack/react-router';
import './styles/theme.css';
import { ApiProvider } from './lib/api-provider';
import { router } from './v2/router';
import { applyStoredTheme } from './v2/theme';

// autoUpdate — never strand a tech on a stale bundle during founding-shop feedback.
registerSW({ immediate: true });

// Apply the stored theme override before first paint (system is the default).
applyStoredTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApiProvider>
      <RouterProvider router={router} />
    </ApiProvider>
  </StrictMode>,
);
